<template>
  <v-app-bar app clipped-left class="colorDominant colorAppBar"
    ><img
      class="mr-1"
      :style="{
        'max-width': $vuetify.breakpoint.smAndDown ? '100px' : '200px',
        'max-height': '48px',
      }"
      aspect-ratio="1.0"
      :src="
        $operatorLogoUrl(domain)
      "
      :alt="domain"
    />

    <!-- v-spacer para quando o Agent está na página de Login, empurrar o btn-languages para o final
    da appBarAgent -->
    <v-spacer
      v-if="this.$route.path === `/page/login/auth/${domain}`"
    ></v-spacer>
    <template v-if="!$vuetify.breakpoint.xsOnly">
      <ButtonLanguages />
    </template>
  </v-app-bar>
</template>
<script>
import ButtonLanguages from "@/components/btn-languages/btn-languages";
export default {
  name: "appBarAgent",
  components: {
    ButtonLanguages,
  },
  data: () => ({
    // client: '',
    domain: "",
  }),
  mounted() {
    this.domain = this.$domain();
    // this.client = this.$store.state.operators.operator_name;
  },
};
</script>
